import type { Locale } from "@/i18n";

interface PainPointsCopy {
  sectionLabel: string;
  lines: readonly string[];
  closing: string;
  ctaLabel: string;
}

const en: PainPointsCopy = {
  sectionLabel: "Sound familiar?",
  lines: [
    "You asked for a quote once, then decided to keep living with the spreadsheet.",
    "A project has been slipping for months, and you no longer believe it will ship.",
    "Your IT person knows a bit of everything, but has never shipped software.",
    "The quote was bigger than the problem itself.",
    "You cannot tell whether what you want is two weeks of work or half a year.",
  ],
  closing: "All five can be solved.",
  ctaLabel: "Tell us which one is yours →",
};

const hu: PainPointsCopy = {
  sectionLabel: "Ismerős?",
  lines: [
    "Egyszer már kértél ajánlatot, aztán mégis inkább maradtál az Excelnél.",
    "Hónapok óta csúszik egy fejlesztés, és már nem hiszed, hogy valaha is elkészül.",
    "Az informatikusod mindenhez ért egy kicsit, de szoftvert még nem szállított.",
    "Az árajánlat nagyobb volt, mint maga a probléma.",
    "Nem tudod, hogy amit szeretnél, az két hét munka vagy fél év.",
  ],
  closing: "Mind az öt megoldható.",
  ctaLabel: "Mondd el, melyik a tiéd →",
};

export const PAIN_POINTS: Record<Locale, PainPointsCopy> = {
  en,
  hu,
};
